/**
 * Filestorage Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UpdateFileInfoVM { 
    fileId: string;
    name?: string | null;
    fileKey?: string | null;
    description?: string | null;
    fullName: string;
    contentType?: string | null;
    modifiedBy?: string | null;
    isDeleted?: boolean;
    isActive?: boolean;
    referenceId?: string | null;
    referenceType?: string | null;
    organizationId: number;
    mnemonic: string;
}

